export default "__VITE_ASSET__DOF5vtry__"